import emotion from 'emotion/dist/emotion.umd.min.js';

const { css } = emotion;

export const primaryColour = '#dd5900';
